import { RESOURCE_LIBRARy_APIS } from "libs/apis/resource-library.api";
import { USER_APIS } from "libs/apis/users.api";
import { useNavigate } from "react-router-dom";
import { successToaster } from "utils/helpers/common/alert-service";
import { CreateResourceLibraryDTO } from "utils/helpers/models/resource-library/resource-library.dto";
import { UserDTO } from "utils/helpers/models/users/user.dto";

const useExperiencesEvents = () => {
  // const getAllEvents = async (
  //   setData: Function,
  //   queryParams: any = {},
  //   setFilters?: Function
  // ) => {
  //   const response = await USER_APIS.getAllEvents(queryParams);
  //   const { status = false, data = null } = response || {};
  //   if (status) {
  //     const { content = [], page = 0, size = 50 } = data || {};
  //     setData(content);
  //     setFilters((filters) => ({ ...filters, page, size }));
  //   }
  // };

  const getAllEvents = async (setData: Function, queryParams: any = {}, setFilters?: Function, setTotalElements?: Function) => {
    const response = await USER_APIS.getAllEvents(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const { content = [], pageNumber = 0, pageSize = 10, totalElements = 0 } = data;
      setData(content);
      setFilters((prev) => ({ ...prev, page: Number(pageNumber) + 1, limit: pageSize }));
      setTotalElements?.(totalElements);
    }
  };


  const activateUser = async (userId: number) => {
    const response = await USER_APIS.activateUser(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const deactivateUser = async (userId: number) => {
    const response = await USER_APIS.deactivateUser(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  return {
    getAllEvents,
    activateUser,
    deactivateUser,
  };
};

export default useExperiencesEvents;
